module.exports = __webpack_public_path__ + "static/media/banner_autoRoulette-half.3620fd99.png";